<template>
  <v-container fill-height>
    <v-layout column>
      <v-flex style="flex: 0 0 auto !important">
        <h1>{{translateUI('MapHarti', lang)}}</h1>
        <v-container fluid grid-list-md class="pa-0">
          <v-data-iterator
            :items="items"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            content-tag="v-layout"
            row
            wrap
            no-data-text="Nu exista harti"
            no-results-text="Nu exista harti conform criteriului de cautare"
            rows-per-page-text="Harti pe pagina">
            <template v-slot:item="props">
              <v-flex xs12 sm6 md4 lg3>
                <v-card style="height: 100%">
                  <v-img
                    :src="host + '/ss/' + props.item._id + '.png'"
                    aspect-ratio="2.75"
                    @click="loadMap(props.item)"
                    style="cursor: pointer">
                  </v-img>

                  <v-card-title primary-title @click="loadMap(props.item)">
                    <div>
                      <h3 class="headline mb-0 primary--text" style="cursor: pointer">{{ translateUI(props.item.denumire, lang) }}</h3>
                      <div> {{ translateUI(props.item.descriere, lang) }} </div>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex>
            </template>
          </v-data-iterator>
        </v-container>
      </v-flex>
      <v-flex style="flex: 1 1 auto !important; min-height: 75vh; margin-bottom: 68px !important">
        <div style="height: 100%" v-if="selectedItem">
          <v-toolbar height="84">
            <v-select :items="sheets" :label="translateUI('MapSheet', lang)" v-model="selectedSheet"></v-select>
            <v-text-field @input="setZoom" :value="zoom" type="number" :step="0.01" label="Zoom" :hint="translateUI('MapZoom', lang)" persistent-hint></v-text-field>
            <v-text-field @input="setScale" :value="scale" type="number" :step="0.01" label="Point scale" :hint="translateUI('MapPointScale', lang)" persistent-hint></v-text-field>
            <v-text-field @input="setPointOpacity" :value="pointOpacity" type="number" :step="0.01" :min="0.1" :max="1" label="Point opacity" persistent-hint></v-text-field>
            <v-text-field @input="setPointStroke" :value="pointStroke" type="number" :step="0.01" :min="0" label="Point stroke" persistent-hint></v-text-field>
            <v-text-field @input="setLabelFontSize" :value="labelSize" type="number" :step="0.1" label="Label size" :hint="translateUI('MapFontSize', lang)" persistent-hint></v-text-field>
            <v-switch
              v-model="labelColorLikePointColor"
              :label="translateUI('MapLabelsColor', lang)"
              hide-details>
            </v-switch>
            <v-switch
              v-model="labels"
              :label="translateUI('MapLabels', lang)"
              hide-details>
            </v-switch>
            <v-btn icon @click="disableDefaultUI = !disableDefaultUI">
              <v-icon :color="!disableDefaultUI ? 'primary' : 'grey'">mdi-settings</v-icon>
            </v-btn>
          </v-toolbar>
          <GmapMap
            :center="mapCenter"
            :zoom="zoom"
            :style="{ width: '100%', height: '100%' }"
            :options="{ styles: mapStyles, disableDefaultUI }"
            ref="map"
            id="map"
            class="elevation-3">
            <GmapMarker
              v-for="(point, index) in points"
              :key="index"
              :position="{lat: Number(point.lat), lng: Number(point.long)}"
              :clickable="true"
              :draggable="false"
              :animation="2"
              :icon="{
                path: 'M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0',
                fillColor: getColor(point.color),
                labelOrigin: { x: 0, y: 35 },
                fillOpacity: pointOpacity,
                anchor: { x:0, y: 0 },
                strokeWeight: pointStroke,
                scale: scale
              }"
              @click="pointClicked(point)"
              :label="labels ? { text: point.denumire, color: labelColorLikePointColor ? getColor(point.color) : '#999', fontWeight: 'normal', fontSize: `${labelSize}px` } : ''">
            </GmapMarker>
            <gmap-info-window :position="activePoint ? {lat: Number(activePoint.lat), lng: Number(activePoint.long)} : mapCenter" :opened="!!activePoint" @closeclick="activePoint = null">
              <v-card v-if="!!activePoint" class="elevation-0">
                <v-card-title primary-title class="pa-0">
                  <div>
                    <h3 class="headline">{{activePoint.denumire}} - {{activePoint.judet}}</h3>
                    <div class="title"> {{ activePoint.value.toLocaleString('ro-RO') }} </div>
                    <div class="body-2"> {{ activePoint.text1 }} </div>
                    <div class="body-2"> {{ activePoint.text2 }} </div>
                  </div>
                </v-card-title>
              </v-card>
            </gmap-info-window>
          </GmapMap>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapStyles } from '@/constants/mapStyles'
import debounce from 'lodash.debounce'
import translate from '@/mixins/Translate'

export default {
  name: 'harti-client',
  mixins: [translate],
  data: () => ({
    type: 'hartiClient',
    rowsPerPageItems: [4, 8, 12],
    pagination: {
      rowsPerPage: 4
    },
    selectedItem: null,
    mapCenter: {
      lat: 46.03308197722126,
      lng: 24.905333289473706
    },
    zoom: 7.25,
    scale: 0.5,
    activePoint: null,
    disableDefaultUI: true,
    labels: true,
    labelColorLikePointColor: false,
    labelSize: 8,
    sheets: [],
    allData: {},
    allColors: {},
    selectedSheet: null,
    pointOpacity: 0.6,
    pointStroke: 0.5
  }),
  computed: {
    host () {
      return this.$store.getters.host
    },
    lang () {
      return this.$store.getters['dictionar/lang']
    },
    loading () {
      return this.$store.getters[`${this.type}/loading`]
    },
    items () {
      return this.$store.getters[`${this.type}/items`]
    },
    mapStyles () {
      return [ ...mapStyles ]
    },
    points () {
      if (this.selectedSheet) {
        return this.allData[this.selectedSheet]
      }
    },
    colors () {
      if (this.selectedSheet) {
        return this.allColors[this.selectedSheet]
      }
    }
  },
  methods: {
    loadMap (item) {
      this.selectedItem = item
      this.sheets = Object.keys(this.selectedItem.data)
      if (this.sheets.length) {
        this.selectedSheet = this.sheets[this.sheets.length - 1]
      }
      this.allColors = this.selectedItem.colors
      this.allData = this.selectedItem.data
    },
    pointClicked (point) {
      this.$set(this, 'activePoint', point)
    },
    getColor (value) {
      if (!isNaN(value)) {
        return this.colors[value] || '#000'
      } else {
        return value
      }
    },
    setZoom: debounce(function (value) {
      this.zoom = Number(value)
    }, 500),
    setScale: debounce(function (value) {
      this.scale = Number(value)
    }, 500),
    setLabelFontSize: debounce(function (value) {
      this.labelSize = Number(value)
    }, 500),
    setPointOpacity: debounce(function (value) {
      this.pointOpacity = Number(value) < 0 ? 0 : (Number(value) > 1 ? 1 : Number(value))
    }, 500),
    setPointStroke: debounce(function (value) {
      this.pointStroke = Number(value) < 0 ? 0 : Number(value)
    }, 500)
  },
  created () {
    this.$store.dispatch(`${this.type}/setEventWatchers`)
    this.$store.dispatch(`${this.type}/fetchItems`)
  }
}
</script>
